import { useEffect, useState } from "react";

export const useBrowserPathname = () => {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const sync = () => setPathname(window.location.pathname);

    const wrap =
      (original: History["pushState"]) =>
      (...args: Parameters<History["pushState"]>) => {
        original.apply(history, args);
        sync();
      };

    const pushState = history.pushState.bind(history);
    const replaceState = history.replaceState.bind(history);
    history.pushState = wrap(pushState);
    history.replaceState = wrap(replaceState);
    window.addEventListener("popstate", sync);

    return () => {
      history.pushState = pushState;
      history.replaceState = replaceState;
      window.removeEventListener("popstate", sync);
    };
  }, []);

  return pathname;
};
